import { ActuacionContractual } from '../models/actuacion-contractual.interface';

export interface ActuacionContractualState {
  actuacionesContractuales: ActuacionContractual[];
  selectedActuacionContractual: ActuacionContractual | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  searchResults: ActuacionContractual[];
  lastLoadedAt: number | null;
}

export const initialActuacionContractualState: ActuacionContractualState = {
  actuacionesContractuales: [],
  selectedActuacionContractual: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  deleting: false,
  searchResults: [],
  lastLoadedAt: null
};
